import { DealerWiseServices } from '../services';
import { dealerwiseConstants } from '../constants';
import { alertActions } from '.';

export const DealerWiseAction = {
    getAll,
    loadingData,
    exportData,
    fetchDealers // New action added
};



function getAll(obj) {
    return dispatch => {
        dispatch(request());

        DealerWiseServices.GetDealerInvoicing(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))


            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) {
                    delete v.TotalRows; delete v.CreatedBy;
                    delete v.DocURL; delete v.MappingId; delete v.ProductID
                });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type: dealerwiseConstants.GETALL_REQUEST } }
    function success(datas) { return { type: dealerwiseConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: dealerwiseConstants.GETEXPORT_SUCCESS, datas } }
   
     
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        DealerWiseServices.GetDealerInvoicing(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) {
                    delete v.TotalRows; delete v.CreatedBy;
                    delete v.DocURL; delete v.MappingId; delete v.ProductID
                });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: dealerwiseConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: dealerwiseConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: dealerwiseConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
    return {
        type: dealerwiseConstants.LOADING_REQUEST, isbool
    }
}

// New function to fetch dealer list
function fetchDealers() {
    return dispatch => {
        dispatch(request());
        DealerWiseServices.GetDealers().then(
            response => {
                dispatch(success(response.ResponseData));
            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request() { return { type: dealerwiseConstants.GETDEALERS_REQUEST }; }
    function success(datas) { return { type: dealerwiseConstants.GETDEALERS_SUCCESS, datas }; }
    function failure(error) { return { type: dealerwiseConstants.GETDEALERS_FAILURE, error }; }
}